import { QuickInterval } from '@/api/models/parking/lib/parking.types'

import { DateRange } from './Calendar.types'
import {
  CalendarCustomQuickFilters,
  CalendarQuickFilters,
  ShortQuickFilters
} from './quick-filters'

type CommonProps = {
  calendarType: 'calendar' | 'hours'
  onFilterClick?: () => void
}

interface ShortProps extends CommonProps {
  short: true
  date: Date
  today?: Date
  onChange: (date: Date) => void
}

interface FullProps extends CommonProps {
  short: false
  dateRange: DateRange
  onRangeChange: (range?: DateRange) => void
  customQuickFilters: QuickInterval[]
}

type Props = ShortProps | FullProps

export const QuickFiltersPanel = ({
  short,
  calendarType,
  onFilterClick,
  ...props
}: Props) => {
  const { dateRange, onRangeChange, customQuickFilters } = props as FullProps
  const { date, today, onChange } = props as ShortProps
  if (!short) {
    return (
      <>
        {customQuickFilters && customQuickFilters.length > 0 ? (
          <CalendarCustomQuickFilters
            range={dateRange}
            setRange={onRangeChange}
            customQuickFilters={customQuickFilters}
            calendarType={calendarType}
            onFilterClick={onFilterClick}
          />
        ) : (
          <CalendarQuickFilters range={dateRange} setRange={onRangeChange} />
        )}
      </>
    )
  }

  if (short) {
    return <ShortQuickFilters date={date} today={today} setDate={onChange} />
  }
}
